import { render } from "./hrm-leave-type-modal.vue?vue&type=template&id=10ab1339"
import script from "./hrm-leave-type-modal.vue?vue&type=script&lang=js"
export * from "./hrm-leave-type-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__